import React from "react";
import { Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const RecentTransactionsCard = () => {
  const transactions = [
    {
      name: "Stellar Dynamics",
      id: "#12457",
      amount: "+$245",
      plan: "Basic (Monthly)",
      img: "/assets/img/company/company-02.svg",
    },
    {
      name: "Quantum Nexus",
      id: "#65974",
      amount: "+$395",
      plan: "Enterprise (Yearly)",
      img: "/assets/img/company/company-03.svg",
    },
    {
      name: "Aurora Technologies",
      id: "#22457",
      amount: "+$145",
      plan: "Advanced (Monthly)",
      img: "/assets/img/company/company-05.svg",
    },
    {
      name: "TerraFusion Energy",
      id: "#43412",
      amount: "+$145",
      plan: "Enterprise (Monthly)",
      img: "/assets/img/company/company-07.svg",
    },
    {
      name: "Epicurean Delights",
      id: "#43567",
      amount: "+$977",
      plan: "Premium (Yearly)",
      img: "/assets/img/company/company-08.svg",
    },
  ];

  return (
    <Card className="shadow-sm border-0 d-flex flex-column h-100 m-0">
      <Card.Header className="bg-white d-flex justify-content-between align-items-center">
        <h5 className="mb-0 fw-semibold">Recent Transactions</h5>

        <Link to="/recent-transactions" className="text-decoration-none"  >
         <Button variant="light" size="sm">
          View All
        </Button>
        </Link>
       
      </Card.Header>

      <Card.Body className="flex-grow-1">
        {transactions.map((item, i) => (
          <div
            key={i}
            className="d-flex justify-content-between align-items-center mb-3"
          >
            <div className="d-flex align-items-center">
              <div className="bg-light rounded-circle p-2 me-3">
                <img src={item.img} alt="" width="32" />
              </div>
              <div>
                <h6 className="mb-1 fw-semibold">{item.name}</h6>
                <small>
                  <span className="text-info">{item.id}</span> • 14 Jan 2025
                </small>
              </div>
            </div>

            <div className="text-end">
              <h6 className="mb-1 fw-semibold">{item.amount}</h6>
              <small className="text-muted">{item.plan}</small>
            </div>
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default RecentTransactionsCard;
